//#region ../../node_modules/.pnpm/@myparcel+ts-utils@1.13.1/node_modules/@myparcel/ts-utils/lib/index.js
function e(e, t) {
	return e?.[t] !== void 0;
}
//#endregion
//#region ../../node_modules/.pnpm/@myparcel+sdk@4.4.2/node_modules/@myparcel/sdk/lib/index.js
var t = Object.defineProperty, n = (e, n, r) => n in e ? t(e, n, {
	enumerable: !0,
	configurable: !0,
	writable: !0,
	value: r
}) : e[n] = r, r = (e, t, r) => n(e, typeof t == "symbol" ? t : t + "", r), i = class {
	constructor() {
		r(this, "fns"), this.fns = [];
	}
	delete(e) {
		let t = this.fns.indexOf(e);
		t !== -1 && (this.fns = [...this.fns.slice(0, t), ...this.fns.slice(t + 1)]);
	}
	use(e) {
		this.fns = [...this.fns, e];
	}
}, a = class e extends Error {
	constructor(t) {
		super(t), r(this, "name", "user"), Object.setPrototypeOf(this, e.prototype), this.name = "UserException";
	}
}, o = class e extends Error {
	constructor(t) {
		super(t.message), r(this, "data"), Object.setPrototypeOf(this, e.prototype), this.name = "ApiException", this.data = t;
	}
}, s = (e, t) => {
	if (t) {
		let n = Object.entries(t).map(([e, t]) => `${e}=${t}`);
		n.length && (e += `?${n.join("&")}`);
	}
	return e;
}, c = ["POST", "PUT"], l = class {
	constructor(e) {
		r(this, "interceptors"), r(this, "baseUrl"), r(this, "headers"), r(this, "parameters"), r(this, "options"), r(this, "_requiredHeaders", []), this.baseUrl = (e?.baseUrl ?? "https://api.myparcel.nl").replace(/\/+$/, ""), this.headers = e?.headers ?? {}, this.parameters = e?.parameters ?? {}, this.options = e?.options ?? {}, this.interceptors = {
			request: new i(),
			response: new i()
		};
	}
	get requiredHeaders() {
		return this._requiredHeaders;
	}
	set requiredHeaders(e) {
		this._requiredHeaders = e;
	}
	async doRequest(t, n) {
		let r = this.normalizeOptions(t, {
			...n,
			...this.options
		});
		this.validateHeaders(t, r);
		let i = await this.request(t, r);
		for (let e of this.interceptors.response.fns) i = await e(i);
		if (e(i, "errors")) throw new o(i);
		return this.getResponseBody(t, i);
	}
	getResponseBody(t, n) {
		if (!e(n, "data")) return n;
		let r = t.getResponseProperty();
		if (!r) return n.data;
		let { page: i, size: a, results: o } = n.data;
		return i === void 0 && a === void 0 && o === void 0 ? n.data[r] : {
			[r]: n.data[r],
			...i !== void 0 && { page: i },
			...a !== void 0 && { size: a },
			...o !== void 0 && { results: o }
		};
	}
	getHeaders() {
		return {
			Accept: "application/json",
			...this.headers
		};
	}
	createUrl(e, t) {
		let n = e.getPath();
		if (n.length && !n.startsWith("/") && (n = `/${n}`), t != null && t.path && (n = this.substitutePath(n, t.path)), n.includes("/:")) throw new a(`One or more path variables are missing in ${n}`);
		return t != null && t.parameters && (n = s(n, t.parameters)), this.baseUrl + n;
	}
	substitutePath(e, t) {
		return t && Object.entries(t).forEach(([t, n]) => {
			e = e.replace(`:${t}`, String(n));
		}), e.includes(":") && e.match(/:\w+?\?/g)?.forEach((t) => {
			e = e.replace(`/${t}`, "");
		}), e;
	}
	validateHeaders(e, t) {
		let n = Object.entries(t.headers).reduce((e, [t, n]) => ({
			...e,
			[t.toLowerCase()]: n
		}), {}), r = this.requiredHeaders.filter((e) => !(e.toLowerCase() in n));
		if (r.length) throw new a(`Required headers are missing: ${r.join(", ")}`);
	}
	normalizeOptions(t, n) {
		let r = {
			...n,
			parameters: {
				...this.parameters,
				...n.parameters,
				...t.getParameters()
			},
			headers: {
				...c.includes(t.method) ? { "Content-Type": "application/json" } : {},
				...this.getHeaders(),
				...n.headers,
				...t.getHeaders()
			}
		};
		if (e(n, "body")) {
			let e = t.getProperty();
			if (n.body instanceof FormData) return r.body = n.body, delete r.headers["Content-Type"], r;
			r.body = e === void 0 ? { data: n.body } : { data: { [e]: n.body } };
		}
		return r;
	}
}, ee = (e) => {
	try {
		return JSON.parse(e), !0;
	} catch {
		return !1;
	}
}, te = class extends l {
	constructor(t) {
		super(t), r(this, "request", async (t, n) => {
			var r, i, a;
			for (let e of this.interceptors.request.fns) n = await e(n);
			let o = t.getTimeout() ?? n.timeout, s = new AbortController(), c = {
				method: t.method,
				headers: n.headers,
				signal: s.signal
			}, l;
			o && (l = setTimeout(() => {
				s.abort();
			}, o)), e(n, "body") && (c.body = n.body instanceof FormData ? n.body : JSON.stringify(n.body));
			try {
				let e = await fetch(this.createUrl(t, n), c);
				if (e.body) {
					if ((r = e.headers.get("Content-Disposition")) != null && r.includes("attachment") || (i = e.headers.get("Content-Type")) != null && i.includes("application/pdf")) return e.blob();
					let t = await e.text();
					return (a = e.headers.get("Content-Type")) != null && a.includes("application/json") && ee(t) ? JSON.parse(t) : t;
				}
			} finally {
				l && clearTimeout(l);
			}
		});
	}
}, ne = class {
	constructor(e) {
		r(this, "method", "GET"), r(this, "property"), r(this, "responseProperty"), r(this, "timeout"), r(this, "headers"), r(this, "parameters"), this.headers = e?.headers ?? {}, this.parameters = e?.parameters ?? {};
	}
	getHeaders() {
		return this.headers;
	}
	getParameters() {
		return this.parameters;
	}
	getPath() {
		return this.path;
	}
	getProperty() {
		return this.property;
	}
	getResponseProperty() {
		return this.responseProperty ?? this.property;
	}
	getTimeout() {
		return this.timeout;
	}
}, u = class extends ne {}, d = class extends ne {};
function re(e, t) {
	if (!t.length) throw new a("At least one endpoint must be passed.");
	return {
		...t.reduce((t, n) => ({
			...t,
			[n.name]: async (t) => e.doRequest(n, t ?? {})
		}), {}),
		client: e
	};
}
var ie = (e, t) => (e.requiredHeaders = ["Authorization"], re(e, t)), ae = (e, t) => re(e, t), oe = class extends u {
	name = "getAccountActiveBrackets";
	path = "accounts/:account_id/active_brackets";
	property = "active_brackets";
}, se = class extends u {
	name = "getAccountBrackets";
	path = "account_brackets";
	property = "account_brackets";
}, ce = class extends u {
	method = "PUT";
	name = "putAccountBrackets";
	path = "account_brackets";
	property = "account_brackets";
}, le = class extends u {
	method = "POST";
	name = "postAccountCarrierOptions";
	path = "accounts/:shop_id/carrier_options";
	property = "carrier_options";
}, ue = class extends u {
	method = "DELETE";
	name = "deleteAccountCarrierOption";
	path = "accounts/:account_id/carrier_options/:carrier_options_id";
	property = "carrier_options";
}, de = class extends u {
	method = "DELETE";
	name = "deleteAccountMessage";
	path = "account_messages/:id";
	property = "messages";
}, fe = class extends u {
	name = "getAccountMessages";
	path = "account_messages";
	property = "messages";
}, pe = class extends u {
	method = "DELETE";
	name = "deleteAccountProductPrices";
	path = "account_product_prices/:price_id";
}, me = class extends u {
	name = "getAccountProductPrices";
	path = "account_product_prices";
	property = "account_products";
}, he = class extends u {
	method = "POST";
	name = "postAccountProductPrices";
	path = "account_product_prices";
	property = "account_product_prices";
	responseProperty = "prices";
}, ge = class extends u {
	name = "getAccountSupportCases";
	path = "accounts/:id/support_cases";
	property = "support_cases";
}, _e = {
	Requested: "requested",
	Active: "active",
	Cancelled: "cancelled",
	Inactive: "inactive"
}, ve = class extends u {
	name = "getAccount";
	path = "accounts/:id";
	property = "accounts";
	timeout = 2e4;
}, ye = class extends u {
	name = "getAccounts";
	path = "accounts";
	property = "accounts";
	timeout = 2e4;
}, be = class extends u {
	method = "PUT";
	name = "putAccount";
	path = "accounts";
	property = "accounts";
}, xe = class extends u {
	method = "POST";
	name = "postAccountsAnonymize";
	path = "accounts/anonymize";
	property = "anonymize_accounts";
}, Se = class extends u {
	method = "GET";
	name = "getAcl";
	path = "acl";
}, Ce = class extends u {
	name = "getAclRolesCustomer";
	path = "acl/roles/customer";
	property = "roles";
}, we = class extends u {
	name = "getAclRolesAdmin";
	path = "acl/roles/admin";
	property = "roles";
}, Te = class extends u {
	method = "DELETE";
	name = "deleteAddress";
	path = "addresses/:id";
	property = "addresses";
}, Ee = class extends u {
	method = "DELETE";
	name = "deleteAddresses";
	path = "addresses/:ids";
	property = "addresses";
}, De = class extends u {
	name = "getAddress";
	path = "addresses/:id";
	property = "addresses";
}, Oe = class extends u {
	name = "getAddresses";
	path = "addresses";
	property = "addresses";
}, ke = class extends u {
	method = "POST";
	name = "postAddress";
	path = "addresses";
	property = "addresses";
	responseProperty = "ids";
}, f = class extends u {
	method = "PUT";
	name = "putAddress";
	path = "addresses";
	property = "addresses";
}, Ae = class extends u {
	method = "POST";
	name = "postMarkCreditInvoices";
	path = "admin/actions/mark_credit_invoices";
	property = "mark_credit_invoices";
}, je = class extends u {
	name = "getAnalyticsDashboards";
	path = "auth/cumulio/token";
}, Me = class extends u {
	name = "getApiKeys";
	path = "keys";
	property = "api_keys";
}, Ne = class extends u {
	method = "POST";
	name = "postApiKeys";
	path = "keys";
	property = "api_keys";
}, Pe = class extends u {
	name = "getBaseProductPrices";
	path = "base_product_prices";
	property = "base_products";
}, Fe = class extends u {
	name = "getSepaInstructions";
	path = "billing/sepa_instructions";
	method = "GET";
}, Ie = class extends u {
	name = "postSepaInstructionsCredit";
	path = "billing/sepa_instructions/credit";
	method = "POST";
}, Le = class extends u {
	name = "postSepaInstructionsDebit";
	path = "billing/sepa_instructions/debit";
	method = "POST";
}, Re = class extends u {
	name = "postEmailCollectionAgencyReport";
	path = "billing/email_collection_agency_report";
	method = "POST";
}, ze = class extends u {
	name = "postEmailUnpaidInvoices";
	path = "billing/email_unpaid_invoices";
	method = "POST";
}, p = class extends u {
	name = "getBillingMethods";
	path = "shops/:shop_id/billing_methods";
	property = "billing_methods";
}, m = class extends u {
	name = "getBracketRanges";
	path = "bracket_ranges/:platform_id";
}, h = class extends u {
	name = "getBrackets";
	path = "brackets/:platform_id";
}, Be = class extends u {
	method = "POST";
	name = "postBrandingBannerImage";
	path = "shops/:shop_id/images/branding_banner";
	property = "branding_banner";
	responseProperty = "ids";
}, Ve = class extends u {
	method = "DELETE";
	name = "deleteBrandingBannerImage";
	path = "shops/:shop_id/images/branding_banner";
	property = "branding_banner";
}, He = class extends u {
	name = "getCarrierConfigurations";
	path = "shops/:shop_id/carrier_configurations";
	property = "carrier_configurations";
}, Ue = class extends u {
	method = "POST";
	name = "postCarrierConfiguration";
	path = "shops/:shop_id/carriers/:carrier_id/carrier_configuration";
	property = "carrier_configurations";
}, We = class extends u {
	method = "DELETE";
	name = "deleteCarrierOption";
	path = "accounts/:account_id/carrier_options/:contract_id";
	property = "carrier_options";
}, Ge = class extends u {
	name = "getCarrierOptions";
	path = "carrier_management/accounts/:account_id/carrier_options";
	property = "carrier_options";
}, Ke = class extends u {
	method = "POST";
	name = "postCarrierOptions";
	path = "accounts/:account_id/carrier_options";
	property = "carrier_options";
	responseProperty = "ids";
}, qe = class extends u {
	method = "PUT";
	name = "putCarrierOptions";
	path = "carrier_management/accounts/:account_id/carrier_options";
	property = "carrier_options";
}, Je = class extends u {
	method = "DELETE";
	name = "deleteCollectTrip";
	path = "collect_trip/:id";
	property = "collect_trip";
}, Ye = class extends u {
	method = "DELETE";
	name = "deleteCollectTripSchedule";
	path = "collect_trip_schedule/:id";
	property = "collect_trip";
}, Xe = class extends u {
	name = "getCollectTripDisabledDays";
	path = "collect_trip_disabled_days";
}, Ze = class extends u {
	name = "getCollectTripSchedules";
	path = "collect_trip_schedule";
}, Qe = class extends u {
	name = "getCollectTrips";
	path = "collect_trip";
}, $e = class extends u {
	method = "POST";
	name = "postConnectAffiliates";
	path = "connect_affiliates";
	property = "affiliates";
}, et = class extends u {
	name = "getCheckSubdomain";
	path = "consumer_portal/check_subdomain";
	property = "branding_banner";
}, tt = class extends u {
	name = "getConsumerPortalFields";
	path = "consumer_portal/fields/:shop_id";
	property = "fields";
}, nt = class extends u {
	method = "PUT";
	name = "putConsumerPortalFields";
	path = "consumer_portal/fields";
	property = "fields";
}, rt = class extends u {
	method = "POST";
	name = "postDeliveryNotifications";
	path = "delivery_notifications";
	property = "shipments";
	responseProperty = "ids";
}, it = class extends u {
	name = "getDeliveryOptions";
	path = "delivery_options";
	property = "deliveries";
	/* c8 ignore next 6 */
	getHeaders() {
		return {
			...super.getHeaders(),
			Accept: "application/json;charset=utf-8;version=2.0"
		};
	}
}, at = class extends u {
	name = "getDimensionsPresets";
	path = "dimensions_presets";
	property = "dimensions_presets";
}, ot = class extends u {
	name = "getDimensionsPreset";
	path = "dimensions_presets/:id";
	property = "dimensions_presets";
}, st = class extends u {
	method = "PATCH";
	name = "patchDimensionsPresets";
	path = "dimensions_presets";
	property = "dimensions_presets";
}, ct = class extends u {
	method = "POST";
	name = "postDimensionsPresets";
	path = "dimensions_presets";
	property = "dimensions_presets";
}, lt = class extends u {
	method = "PUT";
	name = "putDimensionsPresets";
	path = "dimensions_presets";
	property = "dimensions_presets";
}, ut = class extends u {
	method = "DELETE";
	name = "deleteDimensionsPresets";
	path = "dimensions_presets/:id";
	property = "dimensions_presets";
}, dt = class extends u {
	name = "getDirectDebitBanks";
	path = "direct_debit_banks";
	property = "banks";
}, ft = class extends u {
	name = "getDirectDebitMandate";
	path = "shops/:shop_id/direct_debit_mandate";
	property = "mandates";
}, pt = class extends u {
	method = "POST";
	name = "postDirectDebitMandate";
	path = "shops/:shop_id/direct_debit_mandate";
}, mt = class extends u {
	method = "DELETE";
	name = "deleteDirectDebitMandate";
	path = "shops/:shop_id/direct_debit_mandate";
}, ht = class extends u {
	name = "getDropOffPoints";
	path = "carriers/:carrier_id/drop_off_points";
	property = "drop_off_points";
}, gt = class extends u {
	name = "getEmails";
	path = "emails";
	property = "email_templates";
}, _t = class extends u {
	method = "PUT";
	name = "putEmail";
	path = "emails";
	property = "email_templates";
}, vt = class extends u {
	name = "getEoriNumberCheck";
	path = "eori_number/check";
	responseProperty = "valid";
}, yt = class extends u {
	method = "DELETE";
	name = "deleteExternalIntegrationsProviderCredentialsAmazon";
	path = "external_integration_provider_credentials/amazon/:id";
	property = "credentials";
}, bt = class extends u {
	name = "getExternalIntegrationsProviderCredentialsAmazon";
	path = "external_integration_provider_credentials/amazon";
	property = "credentials";
}, xt = class extends u {
	method = "POST";
	name = "postExternalIntegrationsProviderCredentialsAmazon";
	path = "external_integration_provider_credentials/amazon/selling_partner";
	property = "credentials";
	responseProperty = "redirect_url";
}, St = class extends u {
	method = "PUT";
	name = "putExternalIntegrationsProviderCredentialsAmazon";
	path = "external_integration_provider_credentials/amazon";
	property = "credentials";
	responseProperty = "ids";
}, Ct = class extends u {
	name = "getExternalIntegrationsProviderCredentialsBol";
	path = "external_integration_provider_credentials/bol_dot_com/v3";
	property = "credentials";
}, wt = class extends u {
	method = "POST";
	name = "postExternalIntegrationsProviderCredentialsBol";
	path = "external_integration_provider_credentials/bol_dot_com/v3";
	property = "credentials";
	responseProperty = "redirect_url";
}, Tt = class extends u {
	method = "DELETE";
	name = "deleteExternalIntegrationsProviderCredentialsBol";
	path = "external_integration_provider_credentials/bol_dot_com/:id";
	property = "credentials";
}, Et = class extends u {
	method = "PUT";
	name = "putExternalIntegrationsProviderCredentialsBol";
	path = "external_integration_provider_credentials/bol_dot_com/v3";
	property = "credentials";
	responseProperty = "ids";
}, Dt = class extends u {
	name = "getExternalIntegrationsProviderCredentialsEtsy";
	path = "external_integration_provider_credentials/etsy";
	property = "credentials";
}, Ot = class extends u {
	method = "POST";
	name = "postExternalIntegrationsProviderCredentialsEtsy";
	path = "external_integration_provider_credentials/etsy";
	property = "credentials";
	responseProperty = "redirect_url";
}, kt = class extends u {
	method = "DELETE";
	name = "deleteExternalIntegrationsProviderCredentialsEtsy";
	path = "external_integration_provider_credentials/etsy/:id";
	property = "credentials";
}, At = class extends u {
	method = "PUT";
	name = "putExternalIntegrationsProviderCredentialsEtsy";
	path = "external_integration_provider_credentials/etsy";
	property = "credentials";
	responseProperty = "ids";
}, jt = class extends u {
	name = "getExternalIntegrationsProviderCredentialsExact";
	path = "external_integration_provider_credentials/exact";
	property = "credentials";
}, Mt = class extends u {
	method = "POST";
	name = "postExternalIntegrationsProviderCredentialsExact";
	path = "external_integration_provider_credentials/exact";
	property = "credentials";
	responseProperty = "redirect_url";
}, Nt = class extends u {
	method = "DELETE";
	name = "deleteExternalIntegrationsProviderCredentialsExact";
	path = "external_integration_provider_credentials/exact/:id";
	property = "credentials";
}, Pt = class extends u {
	method = "PUT";
	name = "putExternalIntegrationsProviderCredentialsExact";
	path = "external_integration_provider_credentials/exact";
	property = "credentials";
	responseProperty = "ids";
}, Ft = class extends u {
	name = "getExternalIntegrationsProviderCredentialsExactDe";
	path = "external_integration_provider_credentials/exact_de";
	property = "credentials";
}, It = class extends u {
	method = "POST";
	name = "postExternalIntegrationsProviderCredentialsExactDe";
	path = "external_integration_provider_credentials/exact_de";
	property = "credentials";
	responseProperty = "redirect_url";
}, Lt = class extends u {
	method = "DELETE";
	name = "deleteExternalIntegrationsProviderCredentialsExactDe";
	path = "external_integration_provider_credentials/exact_de/:id";
	property = "credentials";
}, Rt = class extends u {
	method = "PUT";
	name = "putExternalIntegrationsProviderCredentialsExactDe";
	path = "external_integration_provider_credentials/exact_de";
	property = "credentials";
	responseProperty = "ids";
}, zt = class extends u {
	method = "POST";
	name = "postExternalIntegration";
	path = "auth/external_integration/:provider";
}, Bt = class extends u {
	name = "getExternalIntegrationsProviderCredentialsWix";
	path = "external_integration_provider_credentials/wix";
	property = "credentials";
}, Vt = class extends u {
	method = "POST";
	name = "postExternalIntegrationsProviderCredentialsWix";
	path = "external_integration_provider_credentials/wix";
	property = "credentials";
	responseProperty = "redirect_url";
}, Ht = class extends u {
	method = "DELETE";
	name = "deleteExternalIntegrationsProviderCredentialsWix";
	path = "external_integration_provider_credentials/wix/:id";
	property = "credentials";
}, Ut = class extends u {
	method = "PUT";
	name = "putExternalIntegrationsProviderCredentialsWix";
	path = "external_integration_provider_credentials/wix";
	property = "credentials";
	responseProperty = "ids";
}, Wt = class extends u {
	name = "getExternalShipments";
	path = "external_shipments";
	property = "shipments";
}, Gt = class extends u {
	method = "POST";
	name = "postExternalOrders";
	path = "external_shipments";
	property = "shipments";
}, Kt = class extends u {
	method = "POST";
	name = "postExternalShipments";
	path = "external_shipments";
	property = "shipments";
}, qt = class extends u {
	method = "POST";
	name = "postFulfilmentDisable";
	path = "fulfilment/settings/disable";
	property = "fulfilment";
}, Jt = class extends u {
	method = "POST";
	name = "postFulfilmentDisableAutosplit";
	path = "fulfilment/settings/autosplit/disable";
	property = "fulfilment";
}, Yt = class extends u {
	method = "POST";
	name = "postFulfilmentDisablePicqer";
	path = "fulfilment/settings/picqer/disable";
	property = "fulfilment";
}, Xt = class extends u {
	method = "POST";
	name = "postFulfilmentEnable";
	path = "fulfilment/settings/enable";
	property = "fulfilment";
}, Zt = class extends u {
	method = "POST";
	name = "postFulfilmentEnableAutosplit";
	path = "fulfilment/settings/autosplit/enable";
	property = "fulfilment";
}, Qt = class extends u {
	method = "POST";
	name = "postFulfilmentEnablePicqer";
	path = "fulfilment/settings/picqer/enable";
	property = "fulfilment";
}, $t = class extends u {
	method = "POST";
	name = "postFulfilmentMode";
	path = "fulfilment/settings/fulfilment-mode";
	property = "fulfilment";
}, en = [
	new Xt(),
	new qt(),
	new Yt(),
	new Qt(),
	new $t(),
	new Zt(),
	new Jt()
], tn = class extends u {
	name = "getFulfilmentOrders";
	path = "fulfilment/orders";
	property = "orders";
}, nn = class extends u {
	name = "getFulfilmentOrder";
	path = "fulfilment/orders/:uuid";
	property = "orders";
}, rn = class extends u {
	method = "POST";
	name = "postFulfilmentOrders";
	path = "fulfilment/orders";
	property = "orders";
}, an = class extends u {
	method = "PUT";
	name = "putFulfilmentOrders";
	path = "fulfilment/orders";
	property = "orders";
}, on = class extends u {
	method = "DELETE";
	name = "deleteFulfilmentOrder";
	path = "fulfilment/orders/:uuid";
}, sn = class extends u {
	name = "getFulfilmentOrderNotes";
	path = "fulfilment/orders/:orderIdentifier/notes";
	property = "order_notes";
}, cn = class extends u {
	method = "POST";
	name = "postFulfilmentOrderNotes";
	path = "fulfilment/orders/:orderIdentifier/notes";
	property = "order_notes";
}, ln = class extends u {
	method = "PUT";
	name = "putFulfilmentOrderNotes";
	path = "fulfilment/orders/:orderIdentifier/notes";
	property = "order_notes";
}, un = class extends u {
	method = "DELETE";
	name = "deleteFulfilmentOrderNote";
	path = "fulfilment/orders/:orderIdentifier/notes/:noteUuid";
}, dn = class extends u {
	method = "PUT";
	name = "putFulfilmentOrderType";
	path = "fulfilment/orders/:uuid/type";
	property = "orders";
}, fn = class extends u {
	method = "POST";
	name = "postFulfilmentPicqerOrder";
	path = "fulfilment/picqer/orders/:uuid";
}, pn = class extends u {
	name = "getFulfilmentOrderPackingSlip";
	path = "fulfilment/orders/:uuids/packing_slip";
	/* c8 ignore start */
	getHeaders() {
		return {
			...super.getHeaders(),
			Accept: "application/pdf"
		};
	}
}, mn = class extends u {
	name = "getFulfilmentOrderScansheet";
	path = "fulfilment/orders/:uuids/scansheet";
	/* c8 ignore start */
	getHeaders() {
		return {
			...super.getHeaders(),
			Accept: "application/pdf"
		};
	}
}, hn = class extends u {
	name = "getFulfilmentOrderPicklist";
	path = "fulfilment/orders/:uuids/picklist";
	/* c8 ignore start */
	getHeaders() {
		return {
			...super.getHeaders(),
			Accept: "application/pdf"
		};
	}
}, gn = class extends u {
	name = "getImplications";
	path = "shops/:shop_id/shipping_rules/implications";
	property = "implications";
}, _n = class extends u {
	method = "POST";
	name = "postInterimInvoices";
	path = "interim_invoices";
	property = "interim_invoice_requests";
	responseProperty = "ids";
}, vn = class extends u {
	name = "getInterimInvoices";
	path = "pro_forma/:shop_ids";
	property = "proforma_invoices";
	/* c8 ignore next 6 */
	getHeaders() {
		return {
			...super.getHeaders(),
			Accept: "application/json;charset=utf-8"
		};
	}
}, yn = class extends u {
	name = "getInvitations";
	path = "invitations";
	property = "invitations";
}, bn = class extends u {
	method = "POST";
	name = "postInvitation";
	path = "invitations";
	property = "invitations";
	responseProperty = "ids";
}, xn = class extends u {
	method = "PUT";
	name = "putInvitation";
	path = "invitations";
	property = "invitations";
}, Sn = class extends u {
	name = "getInvoices";
	path = "invoices";
	property = "invoices";
	/* c8 ignore next 6 */
	getHeaders() {
		return {
			...super.getHeaders(),
			Accept: "application/vnd.invoice_normal+json"
		};
	}
}, Cn = class extends u {
	name = "getInvoiceDetails";
	path = "pro_forma/:shop_id";
	timeout = 2e5;
	/* c8 ignore next 7 */
	getHeaders() {
		return {
			...super.getHeaders(),
			Accept: "application/vnd.invoice+pdf",
			"Content-Type": "application/vnd.invoice+pdf"
		};
	}
}, wn = class extends u {
	name = "getInvoiceItemCategories";
	path = "billing/invoice_item_categories";
	property = "invoice_item_categories";
}, Tn = class extends u {
	method = "POST";
	name = "postInvoiceItems";
	path = "invoice_items";
	property = "invoice_items";
}, En = class extends u {
	method = "POST";
	name = "postSurchargeUploadUrl";
	path = "surcharges/upload-url";
	property = "";
}, Dn = class extends u {
	method = "POST";
	name = "postSpecialInvoices";
	path = "special_invoices";
	property = "invoice_items";
}, On = class extends u {
	method = "PUT";
	name = "putInvoices";
	path = "invoices";
	property = "invoices";
}, kn = class extends u {
	name = "getInvoiceDetailLegacyAttachment";
	path = "invoices/:invoice_id";
	property = "pdfs";
	/* c8 ignore next 6 */
	getHeaders() {
		return {
			...super.getHeaders(),
			Accept: "application/json.invoice_detailed_pdf_link+json"
		};
	}
}, An = class extends u {
	name = "getInvoiceCsvAttachment";
	path = "invoices/:invoice_id";
	response = "pdfs";
	timeout = 2e5;
	/* c8 ignore next 6 */
	getHeaders() {
		return {
			...super.getHeaders(),
			Accept: "application/vnd.invoice_detailed+csv;version=2.0"
		};
	}
}, jn = class extends u {
	name = "getInvoiceDetailAttachment";
	path = "invoices/:invoice_id";
	responseProperty = "pdfs";
	/* c8 ignore next 7 */
	getHeaders() {
		return {
			...super.getHeaders(),
			Accept: "application/vnd.invoice_pdf_link+json"
		};
	}
}, Mn = class extends u {
	name = "getInvoiceShortAttachment";
	path = "invoices/:invoice_id";
	responseProperty = "pdfs";
	/* c8 ignore next 6 */
	getHeaders() {
		return {
			...super.getHeaders(),
			Accept: "application/json.invoice_normal_pdf_link+json"
		};
	}
}, Nn = class extends u {
	name = "getLabelPackagesStatus";
	path = "label_packages_status";
	property = "label_packages_status";
}, Pn = class extends u {
	method = "POST";
	name = "postProcessLabelPackages";
	path = "process_label_packages";
	property = "ids";
}, Fn = class extends u {
	method = "POST";
	name = "postLabelPackages";
	path = "label_packages";
	property = "label_packages";
}, In = class extends u {
	name = "getLocations";
	path = "locations";
	property = "locations";
}, Ln = class extends u {
	name = "getPackagings";
	path = "woocommerce/order";
	property = "orders";
}, Rn = class extends u {
	method = "POST";
	name = "postPackaging";
	path = "woocommerce/order";
	property = "orders";
	responseProperty = "ids";
}, zn = class extends u {
	name = "postPaymentInstructions";
	path = "billing/payment_instructions";
	property = "payment_instruction_requests";
	responseProperty = "payment_instructions";
	method = "POST";
}, Bn = class extends u {
	name = "getPaymentGateways";
	path = "payment_gateways";
	property = "payment_gateways";
}, Vn = class extends u {
	name = "getPickupLocations";
	path = "pickup_locations";
	property = "pickup_locations";
}, Hn = class extends u {
	name = "getProductPrice";
	path = "product_price";
	property = "price";
}, Un = class extends u {
	name = "checkPostalCode";
	path = "postal_code/check";
	property = "postal_code";
}, Wn = class extends u {
	name = "getPriceScaleBrackets";
	path = "accounts/:id/active_brackets/:carrierId";
	property = "active_brackets";
	timeout = 2e5;
}, Gn = class extends u {
	name = "getPhoneNumberCheck";
	path = "/phone_number/check";
	property = "phone_number";
}, Kn = class extends u {
	method = "POST";
	name = "postShipmentCarrierPrice";
	path = "shipments/carrier_price";
	property = "shipments";
	responseProperty = "carrier_price";
}, qn = class extends u {
	name = "getShipment";
	path = "shipments/:id";
	property = "shipments";
}, Jn = class extends u {
	name = "getShipments";
	path = "shipments";
	property = "shipments";
}, Yn = class extends u {
	method = "POST";
	name = "postShipments";
	path = "shipments";
	property = "shipments";
	responseProperty = "ids";
	/* c8 ignore start */
	getHeaders() {
		return {
			...super.getHeaders(),
			"Content-Type": "application/vnd.shipment+json;charset=utf-8;version=1.1"
		};
	}
}, Xn = class extends u {
	method = "PUT";
	name = "putShipments";
	path = "shipments";
	property = "shipments";
	/* c8 ignore start */
	getHeaders() {
		return {
			...super.getHeaders(),
			"Content-Type": "application/vnd.shipment+json;charset=utf-8;version=1.1"
		};
	}
}, Zn = class extends u {
	name = "getShippingRules";
	path = "shipping_rules";
	property = "shipping_rules";
}, Qn = class extends u {
	method = "PATCH";
	name = "patchShippingRule";
	path = "shipping_rules";
	property = "shipping_rules";
}, $n = class extends u {
	method = "POST";
	name = "postShippingRule";
	path = "shipping_rules";
	property = "shipping_rules";
}, er = class extends u {
	method = "PUT";
	name = "putShippingRule";
	path = "shipping_rules";
	property = "shipping_rules";
}, tr = class extends u {
	method = "DELETE";
	name = "deleteShippingRule";
	path = "shipping_rules/:id";
	property = "shipping_rules";
}, nr = class extends u {
	name = "getShopAccess";
	path = "shop_access";
	property = "shop_access";
}, rr = class extends u {
	method = "POST";
	name = "postShopAccess";
	path = "shop_access";
	property = "shop_access";
}, ir = class extends u {
	name = "getShopCarrierOptions";
	path = "carrier_management/shops/:shop_id/carrier_options";
	property = "carrier_options";
}, ar = class extends u {
	method = "POST";
	name = "postShopCarrierOptions";
	path = "shops/:shop_id/carrier_options";
	property = "carrier_options";
}, or = class extends u {
	method = "PUT";
	name = "putShopCarrierOptions";
	path = "carrier_management/shops/:shop_id/carrier_options";
	property = "carrier_options";
}, sr = class extends u {
	method = "DELETE";
	name = "deleteShopCarrierOption";
	path = "shops/:shop_id/carrier_options/:id";
	property = "carrier_options";
}, cr = class extends u {
	method = "DELETE";
	name = "deleteShopImageEmail";
	path = "shops/:shop_id/images/email";
	property = "branding_banner";
}, lr = class extends u {
	method = "POST";
	name = "postShopImageEmail";
	path = "shops/:shop_id/images/email";
	property = "branding_banner";
	responseProperty = "ids";
}, ur = class extends u {
	name = "getReturnContributions";
	path = "shop_return_contributions";
	property = "return_contributions";
}, dr = class extends u {
	name = "postReturnContributions";
	path = "shop_return_contributions";
	property = "return_contributions";
	method = "POST";
}, fr = class extends u {
	name = "putReturnContributions";
	path = "shop_return_contributions";
	property = "return_contributions";
	method = "PUT";
}, pr = class extends u {
	name = "getShopStatistics";
	path = "shops/:shop_id/statistics";
	property = "id";
	responseProperty = "shop_statistics";
}, mr = class extends u {
	name = "getShop";
	path = "shops/:id";
	property = "shops";
}, hr = class extends u {
	method = "POST";
	name = "postShopDuplicate";
	path = "shops/duplicate";
	property = "shops";
	responseProperty = "ids";
}, gr = class extends u {
	method = "PUT";
	name = "putShop";
	path = "shops";
	property = "shops";
}, _r = class extends u {
	name = "getSpecialInvoiceItems";
	path = "special_invoice_items";
	property = "invoice_items";
}, vr = class extends u {
	name = "getStatisticsAffiliateCommission";
	path = "statistics_affiliate_commission";
	property = "statistics_affiliate_commission";
}, yr = class extends u {
	name = "getSubscriptionsCapabilities";
	path = "subscriptions/capabilities";
	property = "capabilities";
}, br = class extends u {
	method = "DELETE";
	name = "deleteSubscription";
	path = "subscriptions/:id";
	property = "subscriptions";
}, xr = class extends u {
	name = "getSubscriptions";
	path = "subscriptions";
	property = "subscriptions";
}, Sr = class extends u {
	method = "PATCH";
	name = "patchSubscriptions";
	path = "subscriptions";
	property = "subscriptions";
	responseProperty = "ids";
}, Cr = class extends u {
	method = "POST";
	name = "postSubscriptions";
	path = "subscriptions";
	property = "subscriptions";
	responseProperty = "ids";
}, wr = class extends u {
	name = "getSupportCase";
	path = "support_cases/:id";
	property = "support_cases";
}, Tr = class extends u {
	method = "PUT";
	name = "putSupportCase";
	path = "support_cases";
	property = "support_cases";
}, Er = class extends u {
	name = "getSupportCaseAttachment";
	path = "support_cases/:case_id/attachments/:attachment_id";
}, Dr = class extends u {
	method = "POST";
	name = "postSupportCaseComment";
	path = "support_cases/:id/comments";
	property = "comments";
}, Or = class extends u {
	name = "getSupportCaseReturnReasons";
	path = "return_shipment/:shipment_id/return_reasons";
	property = "return_reasons";
}, kr = class extends u {
	name = "getSystemCountryCodes";
	path = "system_country_codes";
	property = "countries";
}, Ar = class extends u {
	method = "DELETE";
	name = "deleteSystemMessages";
	path = "system_messages/:id";
	property = "messages";
}, jr = class extends u {
	method = "PUT";
	name = "putSystemMessages";
	path = "system_messages";
	property = "messages";
}, Mr = class extends u {
	method = "POST";
	name = "postSystemMessages";
	path = "system_messages";
	property = "messages";
}, Nr = class extends u {
	name = "getSystemShipmentOptionPrices";
	path = "system_shipment_option_prices";
	property = "shipment_option_prices";
}, Pr = class extends u {
	method = "POST";
	name = "postTicket";
	path = "tickets";
	property = "tickets";
}, Fr = class extends u {
	method = "POST";
	name = "postTicketAttachment";
	path = "tickets/:case_identifier/attachment";
	property = "file";
}, Ir = class extends u {
	name = "getTrackAndTrace";
	path = "tracktraces/:shipment_id";
	property = "tracktraces";
}, Lr = class extends u {
	name = "getUiSettings";
	path = "ui_settings/:account_ids";
	property = "ui_settings";
}, Rr = class extends u {
	method = "POST";
	name = "postUiSettings";
	path = "ui_settings";
	property = "ui_settings";
}, zr = class extends u {
	method = "PUT";
	name = "putUiSettings";
	path = "ui_settings";
	property = "ui_settings";
}, Br = class extends u {
	method = "DELETE";
	name = "deleteUser";
	path = "users/:id";
	property = "users";
}, Vr = class extends u {
	name = "getUser";
	path = "users/:id";
	property = "users";
}, Hr = class extends u {
	name = "getUsers";
	path = "users";
	property = "users";
}, Ur = class extends u {
	method = "POST";
	name = "postUsers";
	path = "users";
	property = "users";
}, Wr = class extends u {
	method = "PUT";
	name = "putUsers";
	path = "users";
	property = "users";
}, Gr = class extends u {
	method = "POST";
	name = "postSendVerificationEmail";
	path = "send_verification_email";
	property = "send_verification_email";
}, Kr = class extends u {
	method = "DELETE";
	name = "deleteWebhookSubscriptions";
	path = "webhook_subscriptions/:ids";
	property = "webhook_subscriptions";
}, qr = class extends u {
	name = "getWebhookSubscriptions";
	path = "webhook_subscriptions";
	property = "webhook_subscriptions";
}, Jr = class extends u {
	method = "POST";
	name = "postWebhookSubscriptions";
	path = "webhook_subscriptions";
	property = "webhook_subscriptions";
	responseProperty = "ids";
}, Yr = class extends d {
	name = "getBranding";
	path = "consumer_portal/branding";
	property = "branding";
}, Xr = class extends d {
	name = "getFields";
	path = "consumer_portal/fields";
	property = "fields";
}, Zr = class extends d {
	name = "checkPostalCode";
	path = "postal_code/check";
	property = "postal_code";
}, Qr = class extends d {
	name = "getSocialShippingLinks";
	path = "consumer_portal/social_shipping_links/:uuid";
	property = "social_shipping_links";
}, $r = class extends d {
	method = "POST";
	name = "postPreRegistration";
	path = "preregistration";
	property = "preregistration";
}, ei = class extends d {
	method = "POST";
	name = "postRegistration";
	path = "registration";
	property = "registration";
	timeout = 15e3;
}, ti = class extends d {
	name = "getCompanyProfile";
	path = "kvk/company_profile/:coc_number";
	property = "company_profile";
}, ni = class extends d {
	name = "getChamberOfCommerceCompanies";
	path = "/kvk/companies";
	property = "companies";
}, ri = class extends d {
	name = "getCheckShopName";
	path = "/check_shop_name";
}, ii = class extends d {
	name = "getLocations";
	path = "locations";
	property = "locations";
}, ai = [new oe()], oi = [new se(), new ce()], si = [new le(), new ue()], ci = [new de(), new fe()], li = [
	new pe(),
	new me(),
	new he()
], ui = [new ge()], di = [
	new ve(),
	new ye(),
	new be()
], fi = [new xe()], pi = [new Se()], mi = [new Ce()], hi = [new we()], gi = [
	new Te(),
	new Ee(),
	new De(),
	new Oe(),
	new ke(),
	new f()
], _i = class extends u {
	method = "POST";
	name = "postUpdateBillingMethod";
	path = "admin/actions/update_billing_method";
	property = "update_billing_method";
}, vi = class extends u {
	method = "POST";
	name = "postUpdateInvoiceStatus";
	path = "admin/actions/update_invoice_status";
	property = "update_invoice_status";
}, yi = [
	new Ae(),
	new _i(),
	new vi()
], bi = [new je()], xi = [new Me(), new Ne()], Si = [new Pe()], Ci = [
	new Fe(),
	new Re(),
	new ze(),
	new Ie(),
	new Le()
], wi = [new p()], Ti = [new m()], Ei = [new h()], Di = [new Be(), new Ve()], Oi = [new He(), new Ue()], ki = [
	new We(),
	new Ge(),
	new Ke(),
	new qe()
], Ai = [
	new Je(),
	new Ye(),
	new Xe(),
	new Ze(),
	new Qe()
], ji = [new $e()], Mi = [new et()], Ni = [new tt(), new nt()], Pi = [new rt()], Fi = [new it()], Ii = [
	new ut(),
	new ot(),
	new at(),
	new st(),
	new ct(),
	new lt()
], Li = [new dt()], Ri = [
	new ft(),
	new pt(),
	new mt()
], zi = [new ht()], Bi = [new gt(), new _t()], Vi = [new vt()], Hi = class extends u {
	method = "GET";
	name = "getExternalIntegration";
	path = "auth/external_integration";
}, Ui = [
	new zt(),
	new Hi(),
	new yt(),
	new bt(),
	new xt(),
	new St(),
	new Tt(),
	new Ct(),
	new wt(),
	new Et(),
	new kt(),
	new Dt(),
	new Ot(),
	new At(),
	new Nt(),
	new jt(),
	new Pt(),
	new Mt(),
	new Lt(),
	new Ft(),
	new It(),
	new Rt(),
	new Ht(),
	new Bt(),
	new Vt(),
	new Ut()
], Wi = [
	new Wt(),
	new Gt(),
	new Kt()
], Gi = [
	new tn(),
	new nn(),
	new rn(),
	new an(),
	new on(),
	new sn(),
	new cn(),
	new ln(),
	new un(),
	new dn(),
	new fn(),
	new pn(),
	new mn(),
	new hn()
], Ki = [new gn()], qi = [new vn(), new _n()], Ji = [
	new yn(),
	new xn(),
	new bn()
], Yi = class extends u {
	name = "getEInvoiceDetail";
	path = "invoices/:invoice_id";
	timeout = 2e5;
	/* c8 ignore next 7 */
	getHeaders() {
		return {
			...super.getHeaders(),
			Accept: "application/vnd.e-invoice+xml"
		};
	}
}, Xi = class extends u {
	name = "getInvoice";
	path = "invoices/:id";
	property = "invoices";
	/* c8 ignore next 6 */
	getHeaders() {
		return {
			...super.getHeaders(),
			Accept: "application/vnd.invoice_normal+json"
		};
	}
}, Zi = class extends u {
	method = "POST";
	name = "postBankTransactions";
	path = "billing/bank_transactions";
	property = "";
}, Qi = class extends u {
	method = "POST";
	name = "postInvoiceTransactions";
	path = "invoice_transactions";
	property = "transactions";
}, $i = class extends u {
	method = "POST";
	name = "postSurcharges";
	path = "surcharges/upload";
	property = "";
}, ea = [
	new Xi(),
	new Sn(),
	new Cn(),
	new jn(),
	new Yi(),
	new An(),
	new kn(),
	new wn(),
	new Mn(),
	new Zi(),
	new Tn(),
	new Qi(),
	new En(),
	new $i(),
	new Dn(),
	new On()
], ta = [
	new Nn(),
	new Pn(),
	new Fn()
], na = [new In()], ra = [new Ln(), new Rn()], ia = [new zn()], aa = [new Bn()], oa = [new Gn()], sa = [new Vn()], ca = [new Un()], la = [new Wn()], ua = [new Hn()], da = [new class extends u {
	name = "getReturnReasons";
	path = "return_reasons";
	property = "return_reasons";
}()], fa = [new Kn()], pa = [new class extends u {
	method = "POST";
	name = "postShipmentCredits";
	path = "shipment_credits";
	property = "shipment_credits";
}()], ma = [new class extends u {
	name = "getShipmentLabels";
	path = "shipment_labels/:ids";
	responseProperty = "payment_instructions";
	/* c8 ignore start */
	getHeaders() {
		return {
			...super.getHeaders(),
			Accept: "application/vnd.shipment_label+pdf"
		};
	}
	timeout = 6e4;
}()], ha = class extends u {
	method = "DELETE";
	name = "deleteShipments";
	path = "shipments/:shipmentIds";
}, ga = class extends u {
	method = "PATCH";
	name = "patchShipments";
	path = "shipments";
	property = "shipments";
	/* c8 ignore start */
	getHeaders() {
		return {
			...super.getHeaders(),
			"Content-Type": "application/vnd.shipment+json;charset=utf-8;version=1.1"
		};
	}
}, _a = [
	new qn(),
	new Jn(),
	new ga(),
	new Yn(),
	new Xn(),
	new ha()
], va = [
	new tr(),
	new Zn(),
	new Qn(),
	new $n(),
	new er()
], ya = [new nr(), new rr()], ba = [
	new ir(),
	new ar(),
	new or(),
	new sr()
], xa = class extends u {
	method = "DELETE";
	name = "deleteShopImageLabel";
	path = "shops/:shop_id/images/label";
	property = "branding_banner";
}, Sa = class extends u {
	method = "POST";
	name = "postShopImageLabel";
	path = "shops/:shop_id/images/label";
	property = "branding_banner";
	responseProperty = "ids";
}, Ca = [
	new cr(),
	new lr(),
	new Sa(),
	new xa()
], wa = [
	new ur(),
	new dr(),
	new fr()
], Ta = [new pr()], Ea = [
	new mr(),
	new hr(),
	new gr()
], Da = [new _r()], Oa = [new vr()], ka = [new yr()], Aa = [
	new br(),
	new xr(),
	new Sr(),
	new Cr()
], ja = [new wr(), new Tr()], Ma = [new Er()], Na = [new Dr()], Pa = [new Or()], Fa = [new kr()], Ia = class extends u {
	method = "GET";
	name = "getSystemMessage";
	path = "system_messages/:id";
	property = "messages";
}, La = class extends u {
	name = "getSystemMessages";
	path = "system_messages";
	property = "messages";
}, Ra = [
	new Ia(),
	new La(),
	new Ar(),
	new jr(),
	new Mr()
], za = [new Nr()], Ba = [new Pr()], Va = [new Fr()], Ha = [new Ir()], Ua = [
	new Lr(),
	new Rr(),
	new zr()
], Wa = [
	new Vr(),
	new Hr(),
	new Br(),
	new Ur(),
	new Wr()
], Ga = [new Gr()], Ka = [
	new Kr(),
	new qr(),
	new Jr()
], qa = [
	...di,
	...Ka,
	...ki,
	...Ai,
	...Aa,
	...ka,
	...Fa,
	..._a,
	...ci,
	...na,
	...xi,
	...Ha,
	...ai,
	...oi,
	...si,
	...li,
	...fi,
	...ui,
	...pi,
	...gi,
	...bi,
	...Si,
	...Ti,
	...Ei,
	...Di,
	...Oi,
	...ji,
	...Ni,
	...Pi,
	...Fi,
	...zi,
	...Ii,
	...Bi,
	...Vi,
	...Ui,
	...Wi,
	...Gi,
	...Ki,
	...qi,
	...Ji,
	...ea,
	...ra,
	...ia,
	...aa,
	...ca,
	...oa,
	...sa,
	...fa,
	...va,
	...Ea,
	...ya,
	...ba,
	...wa,
	...Ta,
	...Da,
	...Ma,
	...Na,
	...Pa,
	...ja,
	...Ra,
	...za,
	...Va,
	...Ba,
	...Ua,
	...Wa,
	...Ga,
	...la,
	...ua,
	...Oa,
	...mi,
	...hi,
	...en,
	...Ea,
	...da,
	...Ci,
	...Ca,
	...Mi,
	...wi,
	...Li,
	...Ri,
	...pa,
	...ma,
	...yi,
	...ta
], Ja = qa, g, _;
function Ya() {
	return {
		sdk: g,
		initSdk: ({ token: e, baseUrl: t, initialLocale: n, getToken: r }) => {
			if (n && (_ = n), g) return g;
			let i = !e && !r, a = new te({
				baseUrl: t,
				headers: { ...e ? { Authorization: `Bearer ${e}` } : {} },
				...i ? { credentials: "include" } : {},
				options: { timeout: 8e3 }
			});
			a.interceptors.request.use(async (e) => {
				let t = localStorage.getItem("x-dmp-feature-flags");
				return e.headers = {
					"x-referer": window.location.href,
					..._ ? { "Accept-Language": _ } : {},
					...t ? { "x-dmp-feature-flags": t } : {},
					...e.headers,
					...r ? { Authorization: `Bearer ${await r()}` } : {}
				}, e;
			});
			let o = ie(a, Ja);
			return i && (a.requiredHeaders = []), g = o, g;
		},
		resetSdk: () => {
			g = void 0;
		},
		setAcceptLanguageHeader: (e) => {
			_ = e;
		}
	};
}
//#endregion
//#region src/endpoints/public/billing/domain.ts
var Xa = [new class extends d {
	name = "getPaymentStatus";
	path = "/billing/payment_status/:hash";
	property = "payment_status";
}()], Za = [new ni(), new ti()], Qa = [new ri()], $a = [new class extends d {
	name = "getCheckUsername";
	path = "check_username";
}()], eo = [new Yr()], to = [new Xr()], no = [new Zr()], ro = [new class extends d {
	name = "getReturnReasonSettings";
	path = "consumer_portal/return_reason_settings";
	property = "return_reason_settings";
}()], io = class extends d {
	name = "getReturnShipment";
	path = "return_shipment/:hash";
	property = "return_shipments";
}, ao = class extends d {
	method = "POST";
	name = "postReturnShipmentLabel";
	path = "return_shipment/email_label";
	property = "return_shipments";
}, oo = class extends d {
	name = "getReturnShipmentReturnReason";
	path = "return_shipment/:hash/return_reasons";
	property = "return_reasons";
}, so = class extends d {
	method = "POST";
	name = "postReturnShipmentReturnComment";
	path = "return_shipment/:hash/return_comment";
	property = "return_comments";
}, co = class extends d {
	method = "POST";
	name = "postReturnShipmentReturnReasons";
	path = "return_shipment/:hash/return_reasons";
	property = "return_reasons";
}, lo = [
	new io(),
	new ao(),
	new co(),
	new so(),
	new oo()
], uo = [new class extends d {
	method = "POST";
	path = "consumer_portal/return_shipments";
	name = "postReturnShipments";
	property = "return_shipments";
}()], fo = class extends d {
	method = "PUT";
	name = "putSocialShippingLinks";
	path = "consumer_portal/social_shipping_links/:uuid";
	property = "social_shipping_links";
}, po = [new Qr(), new fo()], mo = [new ii()], ho = [new class extends d {
	name = "getPhoneNumberCheck";
	path = "/phone_number/check";
	property = "phone_number";
}()], go = [new $r(), new ei()], v = {
	PostNl: 1,
	Bpost: 2,
	CheapCargo: 3,
	Dpd: 4,
	Instabox: 5,
	Dhl: 6,
	Bol: 7,
	Ups: 8,
	DhlForYou: 9,
	DhlParcelConnect: 10,
	DhlEuroPlus: 11,
	UpsStandard: 12,
	UpsExpressSaver: 13,
	Gls: 14,
	Brt: 15,
	Trunkrs: 16,
	InPost: 17,
	PosteItaliane: 18,
	Spring: 19,
	ViaTim: 20,
	DhlFreight: 21
}, y = {
	PostNl: "postnl",
	POSTNL: "POSTNL",
	Bpost: "bpost",
	BPOST: "BPOST",
	CheapCargo: "cheapcargo",
	CHEAP_CARGO: "CHEAP_CARGO",
	Dpd: "dpd",
	DPD: "DPD",
	Instabox: "instabox",
	INSTABOX: "INSTABOX",
	Dhl: "dhl",
	BolCom: "bol.com",
	Bol: "bol",
	BOL: "BOL",
	Ups: "ups",
	UPS: "ups",
	DHL: "DHL",
	DhlForYou: "dhlforyou",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DhlParcelConnect: "dhlparcelconnect",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DhlEuroPlus: "dhleuroplus",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	UpsStandard: "upsstandard",
	UPS_STANDARD: "UPS_STANDARD",
	UpsExpressSaver: "upsexpresssaver",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	Gls: "gls",
	GLS: "GLS",
	Brt: "brt",
	BRT: "BRT",
	Trunkrs: "trunkrs",
	TRUNKRS: "TRUNKRS",
	InPost: "inpost",
	INPOST: "INPOST",
	PosteItaliane: "posteitaliane",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	Spring: "spring",
	SPRING: "SPRING",
	ViaTim: "viatim",
	VIA_TIM: "VIA_TIM",
	DhlFreight: "dhlfreight",
	DHL_FREIGHT: "DHL_FREIGHT"
};
v.Dhl, v.Instabox, v.PostNl, y.PostNl, v.Bpost, y.Bpost, v.CheapCargo, y.CheapCargo, v.Dpd, y.Dpd, v.Instabox, y.Instabox, v.Dhl, y.Dhl, v.Bol, y.Bol, v.Ups, y.Ups, v.DhlForYou, y.DhlForYou, v.DhlParcelConnect, y.DhlParcelConnect, v.DhlEuroPlus, y.DhlEuroPlus, v.UpsStandard, y.UpsStandard, v.UpsExpressSaver, y.UpsExpressSaver, v.Gls, y.Gls, v.Brt, y.Brt, v.Trunkrs, y.Trunkrs, v.InPost, y.InPost, v.PosteItaliane, y.PosteItaliane, v.Spring, y.Spring, v.ViaTim, y.ViaTim, v.DhlFreight, y.DhlFreight, v.PostNl, y.POSTNL, v.Bpost, y.BPOST, v.CheapCargo, y.CHEAP_CARGO, v.Dpd, y.DPD, v.Instabox, y.INSTABOX, v.Dhl, y.DHL, v.Bol, y.BOL, v.Ups, y.UPS, v.DhlForYou, y.DHL_FOR_YOU, v.DhlParcelConnect, y.DHL_PARCEL_CONNECT, v.DhlEuroPlus, y.DHL_EUROPLUS, v.UpsStandard, y.UPS_STANDARD, v.UpsExpressSaver, y.UPS_EXPRESS_SAVER, v.Gls, y.GLS, v.Brt, y.BRT, v.Trunkrs, y.TRUNKRS, v.InPost, y.INPOST, v.PosteItaliane, y.POSTE_ITALIANE, v.Spring, y.SPRING, v.ViaTim, y.VIA_TIM, v.DhlFreight, y.DHL_FREIGHT, y.POSTNL, v.PostNl, y.BPOST, v.Bpost, y.CHEAP_CARGO, v.CheapCargo, y.DPD, v.Dpd, y.INSTABOX, v.Instabox, y.DHL, v.Dhl, y.BOL, v.Bol, y.UPS, v.Ups, y.DHL_FOR_YOU, v.DhlForYou, y.DHL_PARCEL_CONNECT, v.DhlParcelConnect, y.DHL_EUROPLUS, v.DhlEuroPlus, y.UPS_STANDARD, v.UpsStandard, y.UPS_EXPRESS_SAVER, v.UpsExpressSaver, y.GLS, v.Gls, y.BRT, v.Brt, y.TRUNKRS, v.Trunkrs, y.INPOST, v.InPost, y.POSTE_ITALIANE, v.PosteItaliane, y.SPRING, v.Spring, y.VIA_TIM, v.ViaTim, y.DHL_FREIGHT, v.DhlFreight, y.PostNl, v.PostNl, y.POSTNL, v.PostNl, y.Bpost, v.Bpost, y.BPOST, v.Bpost, y.CheapCargo, v.CheapCargo, y.CHEAP_CARGO, v.CheapCargo, y.Dpd, v.Dpd, y.DPD, v.Dpd, y.Instabox, v.Instabox, y.Dhl, v.Dhl, y.BolCom, v.Bol, y.Bol, v.Bol, y.BOL, v.Bol, y.Ups, v.Ups, y.DhlForYou, v.DhlForYou, y.DHL_FOR_YOU, v.DhlForYou, y.DhlParcelConnect, v.DhlParcelConnect, y.DHL_PARCEL_CONNECT, v.DhlParcelConnect, y.DhlEuroPlus, v.DhlEuroPlus, y.DHL_EUROPLUS, v.DhlEuroPlus, y.UpsStandard, v.UpsStandard, y.UPS_STANDARD, v.UpsStandard, y.UpsExpressSaver, v.UpsExpressSaver, y.UPS_EXPRESS_SAVER, v.UpsExpressSaver, y.Gls, v.Gls, y.GLS, v.Gls, y.Brt, v.Brt, y.BRT, v.Brt, y.Trunkrs, v.Trunkrs, y.TRUNKRS, v.Trunkrs, y.InPost, v.InPost, y.INPOST, v.InPost, y.PosteItaliane, v.PosteItaliane, y.POSTE_ITALIANE, v.PosteItaliane, y.Spring, v.Spring, y.SPRING, v.Spring, y.ViaTim, v.ViaTim, y.VIA_TIM, v.ViaTim, y.DhlFreight, v.DhlFreight, y.DHL_FREIGHT, v.DhlFreight, v.PostNl, v.Bpost, v.CheapCargo, v.Dpd, v.Instabox, v.Dhl, v.Bol, v.Ups, v.DhlForYou, v.DhlParcelConnect, v.DhlEuroPlus, v.UpsStandard, v.UpsExpressSaver, v.Gls, v.Brt, v.Trunkrs, v.InPost, v.PosteItaliane, v.Spring, v.ViaTim, v.DhlFreight;
var b = {
	Afghanistan: "AF",
	AlandIslands: "AX",
	Albania: "AL",
	Algeria: "DZ",
	AmericanSamoa: "AS",
	AmericanVirginIslands: "VI",
	Andorra: "AD",
	Angola: "AO",
	Anguilla: "AI",
	Antarctica: "AQ",
	AntiguaAndBarbuda: "AG",
	Argentina: "AR",
	Armenia: "AM",
	Aruba: "AW",
	Australia: "AU",
	Austria: "AT",
	Azerbaijan: "AZ",
	Bahamas: "BS",
	Bahrain: "BH",
	Bangladesh: "BD",
	Barbados: "BB",
	Belarus: "BY",
	Belgium: "BE",
	Belize: "BZ",
	Benin: "BJ",
	Bermuda: "BM",
	Bhutan: "BT",
	Bolivia: "BO",
	BonaireSintEustatiusAndSaba: "BQ",
	BosniaAndHerzegovina: "BA",
	Botswana: "BW",
	BouvetIsland: "BV",
	Brazil: "BR",
	BritishIndianOceanTerritory: "IO",
	BritishVirginIslands: "VG",
	BruneiDarussalam: "BN",
	Bulgaria: "BG",
	BurkinaFaso: "BF",
	Burundi: "BI",
	CaboVerde: "CV",
	Cambodia: "KH",
	Cameroon: "CM",
	Canada: "CA",
	CanaryIslands: "IC",
	CaymanIslands: "KY",
	CentralAfricanRepublic: "CF",
	Chad: "TD",
	Chile: "CL",
	China: "CN",
	ChristmasIsland: "CX",
	CocosIslands: "CC",
	Colombia: "CO",
	Comoros: "KM",
	CongoBrazzaville: "CG",
	CongoKinshasa: "CD",
	CookIslands: "CK",
	CostaRica: "CR",
	CoteDIvoire: "CI",
	Croatia: "HR",
	Cuba: "CU",
	Curacao: "CW",
	Cyprus: "CY",
	CzechRepublic: "CZ",
	Denmark: "DK",
	Djibouti: "DJ",
	Dominica: "DM",
	DominicanRepublic: "DO",
	DutchAntilles: "AN",
	Ecuador: "EC",
	Egypt: "EG",
	ElSalvador: "SV",
	EquatorialGuinea: "GQ",
	Eritrea: "ER",
	Estonia: "EE",
	Eswatini: "SZ",
	Ethiopia: "ET",
	FalklandIslands: "FK",
	FaroeIslands: "FO",
	Fiji: "FJ",
	Finland: "FI",
	France: "FR",
	FrenchGuiana: "GF",
	FrenchPolynesia: "PF",
	FrenchSouthernTerritories: "TF",
	Gabon: "GA",
	Gambia: "GM",
	Georgia: "GE",
	Germany: "DE",
	Ghana: "GH",
	Gibraltar: "GI",
	Greece: "GR",
	Greenland: "GL",
	Grenada: "GD",
	Guadeloupe: "GP",
	Guam: "GU",
	Guatemala: "GT",
	Guernsey: "GG",
	Guinea: "GN",
	GuineaBissau: "GW",
	Guyana: "GY",
	Haiti: "HT",
	HeardIslandAndMcdonaldIslands: "HM",
	HolySee: "VA",
	Honduras: "HN",
	HongKong: "HK",
	Hungary: "HU",
	Iceland: "IS",
	India: "IN",
	Indonesia: "ID",
	Iran: "IR",
	Iraq: "IQ",
	Ireland: "IE",
	IsleOfMan: "IM",
	Israel: "IL",
	Italy: "IT",
	Jamaica: "JM",
	Japan: "JP",
	Jersey: "JE",
	Jordan: "JO",
	Kazakhstan: "KZ",
	Kenya: "KE",
	Kiribati: "KI",
	KoreaPeoplesDemocraticRepublic: "KP",
	KoreaRepublic: "KR",
	Kosovo: "XK",
	Kuwait: "KW",
	Kyrgyzstan: "KG",
	Laos: "LA",
	Latvia: "LV",
	Lebanon: "LB",
	Lesotho: "LS",
	Liberia: "LR",
	Libya: "LY",
	Liechtenstein: "LI",
	Lithuania: "LT",
	Luxembourg: "LU",
	Macao: "MO",
	Madagascar: "MG",
	Malawi: "MW",
	Malaysia: "MY",
	Maldives: "MV",
	Mali: "ML",
	Malta: "MT",
	MarshallIslands: "MH",
	Martinique: "MQ",
	Mauritania: "MR",
	Mauritius: "MU",
	Mayotte: "YT",
	Mexico: "MX",
	Micronesia: "FM",
	Moldova: "MD",
	Monaco: "MC",
	Mongolia: "MN",
	Montenegro: "ME",
	Montserrat: "MS",
	Morocco: "MA",
	Mozambique: "MZ",
	Myanmar: "MM",
	Namibia: "NA",
	Nauru: "NR",
	Nepal: "NP",
	Netherlands: "NL",
	NewCaledonia: "NC",
	NewZealand: "NZ",
	Nicaragua: "NI",
	Niger: "NE",
	Nigeria: "NG",
	Niue: "NU",
	NorfolkIsland: "NF",
	NorthMacedonia: "MK",
	NorthernMarianaIslands: "MP",
	Norway: "NO",
	Oman: "OM",
	Pakistan: "PK",
	Palau: "PW",
	Palestine: "PS",
	Panama: "PA",
	PapuaNewGuinea: "PG",
	Paraguay: "PY",
	Peru: "PE",
	Philippines: "PH",
	Pitcairn: "PN",
	Poland: "PL",
	Portugal: "PT",
	PuertoRico: "PR",
	Qatar: "QA",
	Reunion: "RE",
	Romania: "RO",
	RussianFederation: "RU",
	Rwanda: "RW",
	SaintBarthelemy: "BL",
	SaintHelena: "SH",
	SaintKittsAndNevis: "KN",
	SaintLucia: "LC",
	SaintMartin: "MF",
	SaintPierreAndMiquelon: "PM",
	SaintVincentAndTheGrenadines: "VC",
	Samoa: "WS",
	SanMarino: "SM",
	SaoTomeAndPrincipe: "ST",
	SaudiArabia: "SA",
	Senegal: "SN",
	Serbia: "RS",
	Seychelles: "SC",
	SierraLeone: "SL",
	Singapore: "SG",
	SintMaarten: "SX",
	Slovakia: "SK",
	Slovenia: "SI",
	SolomonIslands: "SB",
	Somalia: "SO",
	SouthAfrica: "ZA",
	SouthGeorgiaAndTheSouthSandwichIslands: "GS",
	SouthSudan: "SS",
	Spain: "ES",
	SriLanka: "LK",
	Sudan: "SD",
	Suriname: "SR",
	SvalbardAndJanMayen: "SJ",
	Sweden: "SE",
	Switzerland: "CH",
	SyrianArabRepublic: "SY",
	Taiwan: "TW",
	Tajikistan: "TJ",
	Tanzania: "TZ",
	Thailand: "TH",
	TimorLeste: "TL",
	Togo: "TG",
	Tokelau: "TK",
	Tonga: "TO",
	TrinidadAndTobago: "TT",
	Tunisia: "TN",
	Turkey: "TR",
	Turkmenistan: "TM",
	TurksAndCaicosIslands: "TC",
	Tuvalu: "TV",
	Uganda: "UG",
	Ukraine: "UA",
	UnitedArabEmirates: "AE",
	UnitedKingdom: "GB",
	UnitedStatesMinorOutlyingIslands: "UM",
	UnitedStatesOfAmerica: "US",
	Uruguay: "UY",
	Uzbekistan: "UZ",
	Vanuatu: "VU",
	Venezuela: "VE",
	Vietnam: "VN",
	WallisAndFutuna: "WF",
	WesternSahara: "EH",
	Yemen: "YE",
	Zambia: "ZM",
	Zimbabwe: "ZW"
};
b.Austria, b.Belgium, b.Bulgaria, b.Croatia, b.Cyprus, b.CzechRepublic, b.Denmark, b.Estonia, b.Finland, b.France, b.Germany, b.Greece, b.Hungary, b.Ireland, b.Italy, b.Latvia, b.Lithuania, b.Luxembourg, b.Malta, b.Netherlands, b.Poland, b.Portugal, b.Romania, b.Slovakia, b.Slovenia, b.Spain, b.Sweden, Object.values(b), b.Angola, b.AntiguaAndBarbuda, b.Aruba, b.Bahamas, b.Belize, b.Benin, b.Bermuda, b.BonaireSintEustatiusAndSaba, b.Botswana, b.BurkinaFaso, b.Burundi, b.Cameroon, b.CanaryIslands, b.CentralAfricanRepublic, b.Comoros, b.CongoBrazzaville, b.CongoKinshasa, b.CoteDIvoire, b.Curacao, b.Djibouti, b.Dominica, b.DutchAntilles, b.EquatorialGuinea, b.Eritrea, b.Fiji, b.Gabon, b.Gambia, b.Ghana, b.Grenada, b.Guyana, b.HongKong, b.Kiribati, b.KoreaPeoplesDemocraticRepublic, b.Macao, b.Malawi, b.Mali, b.Mauritania, b.Nauru, b.Qatar, b.Rwanda, b.SaintKittsAndNevis, b.SaoTomeAndPrincipe, b.Seychelles, b.SierraLeone, b.SintMaarten, b.Suriname, b.SyrianArabRepublic, b.TimorLeste, b.Togo, b.Tonga, b.Tuvalu, b.Uganda, b.UnitedArabEmirates, b.Vanuatu, b.Yemen, b.Zimbabwe, b.Austria, b.Belgium, b.Bulgaria, b.Croatia, b.CzechRepublic, b.Estonia, b.Finland, b.France, b.Germany, b.Greece, b.Hungary, b.Ireland, b.Italy, b.Latvia, b.Lithuania, b.Luxembourg, b.Malta, b.Netherlands, b.Portugal, b.Romania, b.Slovakia, b.Slovenia, b.Spain, b.UnitedKingdom, b.Denmark, b.Germany, b.Sweden;
var x = {
	EarlyMorning: 8,
	Morning: 1,
	Standard: 2,
	Evening: 3,
	Pickup: 4,
	PickupExpress: 5,
	SameDayDelivery: 6,
	Express: 7
}, S = {
	EarlyMorning: "early_morning",
	Morning: "morning",
	Standard: "standard",
	Evening: "evening",
	Pickup: "pickup",
	PickupExpress: "pickup_express",
	SameDayDelivery: "same_day",
	Express: "express"
}, C = {
	EarlyMorning: "EARLY_MORNING_DELIVERY",
	Morning: "MORNING_DELIVERY",
	Standard: "STANDARD_DELIVERY",
	Evening: "EVENING_DELIVERY",
	Pickup: "PICKUP_DELIVERY",
	PickupExpress: "PICKUP_EXPRESS_DELIVERY",
	SameDayDelivery: "SAME_DAY_DELIVERY",
	Express: "EXPRESS_DELIVERY"
};
x.EarlyMorning, S.EarlyMorning, x.Morning, S.Morning, x.Standard, S.Standard, x.Evening, S.Evening, x.Pickup, S.Pickup, x.PickupExpress, S.PickupExpress, x.SameDayDelivery, S.SameDayDelivery, x.Express, S.Express, S.EarlyMorning, x.EarlyMorning, S.Morning, x.Morning, S.Standard, x.Standard, S.Evening, x.Evening, S.Pickup, x.Pickup, S.PickupExpress, x.PickupExpress, S.SameDayDelivery, x.SameDayDelivery, S.Express, x.Express, x.EarlyMorning, C.EarlyMorning, x.Morning, C.Morning, x.Standard, C.Standard, x.Evening, C.Evening, x.Pickup, C.Pickup, x.PickupExpress, C.PickupExpress, x.SameDayDelivery, C.SameDayDelivery, x.Express, C.Express, C.EarlyMorning, S.EarlyMorning, C.Morning, S.Morning, C.Standard, S.Standard, C.Evening, S.Evening, C.Pickup, S.Pickup, C.PickupExpress, S.PickupExpress, C.SameDayDelivery, S.SameDayDelivery, C.Express, S.Express, x.EarlyMorning, x.Morning, x.Standard, x.Evening, x.Pickup, x.PickupExpress, x.SameDayDelivery, x.Express, { Vasco: 1 }.Vasco, { Vasco: "vasco" }.Vasco;
var w = {
	Sunday: 0,
	Monday: 1,
	Tuesday: 2,
	Wednesday: 3,
	Thursday: 4,
	Friday: 5,
	Saturday: 6
}, T = {
	Sunday: "sunday",
	Monday: "monday",
	Tuesday: "tuesday",
	Wednesday: "wednesday",
	Thursday: "thursday",
	Friday: "friday",
	Saturday: "saturday"
};
T.Sunday, w.Sunday, T.Monday, w.Monday, T.Tuesday, w.Tuesday, T.Wednesday, w.Wednesday, T.Thursday, w.Thursday, T.Friday, w.Friday, T.Saturday, w.Saturday, w.Sunday, T.Sunday, w.Monday, T.Monday, w.Tuesday, T.Tuesday, w.Wednesday, T.Wednesday, w.Thursday, T.Thursday, w.Friday, T.Friday, w.Saturday, T.Saturday;
var E = {
	Bytes: "B",
	Kilobytes: "KB",
	Megabytes: "MB",
	Gigabytes: "GB",
	Terabytes: "TB"
};
E.Bytes, E.Kilobytes, E.Megabytes, E.Gigabytes, E.Terabytes;
var D = {
	Bol: 1,
	Exact: 2,
	Amazon: 6,
	Wix: 8,
	ExactDe: 10,
	Etsy: 11
}, O = {
	Bol: "bol_dot_com",
	Wix: "wix",
	Exact: "exact",
	ExactDe: "exact_de",
	Amazon: "amazon",
	Etsy: "etsy"
};
D.Bol, O.Bol, D.Exact, O.Exact, D.Amazon, O.Amazon, D.Wix, O.Wix, D.ExactDe, O.ExactDe, D.Etsy, O.Etsy, O.Bol, D.Bol, O.Exact, D.Exact, O.Amazon, D.Amazon, O.Wix, D.Wix, O.ExactDe, D.ExactDe, O.Etsy, D.Etsy;
var k = {
	Unpaid: 1,
	Due: 101,
	DuePrepayment: 102,
	Reminder1: 106,
	Reminder2: 111,
	Dun: 116,
	Collection: 121,
	Instalments: 126,
	PaymentArrangement: 127,
	Dispute: 128,
	LegalProcedure: 129,
	Insolvency: 130,
	WriteOff: 131,
	Pending: 301,
	Cancelled: 401,
	Paid: 501,
	PaidOnline: 506,
	PaidAutomatic: 511,
	PaidCredit: 597,
	PaidZeroItems: 598,
	InvoiceWith0InvoiceItemsPaidZeroBalance: 599
}, A = {
	Unpaid: "Unpaid",
	Due: "Due",
	DuePrepayment: "DuePrepayment",
	Reminder1: "Reminder1",
	Reminder2: "Reminder2",
	Dun: "Dun",
	Collection: "Collection",
	Instalments: "Instalments",
	PaymentArrangement: "PaymentArrangement",
	Dispute: "Dispute",
	LegalProcedure: "LegalProcedure",
	Insolvency: "Insolvency",
	WriteOff: "WriteOff",
	Pending: "Pending",
	Cancelled: "Cancelled",
	Paid: "Paid",
	PaidOnline: "PaidOnline",
	PaidAutomatic: "PaidAutomatic",
	PaidCredit: "PaidCredit",
	PaidZeroItems: "PaidZeroItems",
	PaidZeroBalance: "PaidZeroBalance"
};
k.Unpaid, A.Unpaid, k.Due, A.Due, k.DuePrepayment, A.DuePrepayment, k.Reminder1, A.Reminder1, k.Reminder2, A.Reminder2, k.Dun, A.Dun, k.Collection, A.Collection, k.Instalments, A.Instalments, k.PaymentArrangement, A.PaymentArrangement, k.Dispute, A.Dispute, k.LegalProcedure, A.LegalProcedure, k.Insolvency, A.Insolvency, k.WriteOff, A.WriteOff, k.Pending, A.Pending, k.Cancelled, A.Cancelled, k.Paid, A.Paid, k.PaidOnline, A.PaidOnline, k.PaidAutomatic, A.PaidAutomatic, k.PaidCredit, A.PaidCredit, k.PaidZeroItems, A.PaidZeroItems, k.InvoiceWith0InvoiceItemsPaidZeroBalance, A.PaidZeroBalance, k.Due, k.Reminder1, k.Reminder2, k.Dun, k.Collection, k.Instalments, k.PaymentArrangement, k.Dispute, k.Paid, k.PaidOnline, k.PaidAutomatic, k.PaidCredit, k.PaidZeroItems;
var _o = {
	Gram: "g",
	Kilogram: "kg"
};
_o.Gram, _o.Kilogram;
var j = {
	Millimeter: "mm",
	Centimeter: "cm",
	Meter: "m"
};
j.Millimeter, j.Centimeter, j.Meter;
var M = {
	Eu: "EU",
	HomeCountry: "Home Country",
	Row: "ROW",
	Cd: "CD",
	World: "WERELD"
}, N = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnRouteHandedToCarrier: 3,
	EnRouteSorting: 4,
	EnRouteDistribution: 5,
	EnRouteCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedLetter: 12,
	InactiveCredited: 13,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnRouteHandedToCarrier: 32,
	InactiveEnRouteSorting: 33,
	InactiveEnRouteDistribution: 34,
	InactiveEnRouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38
};
N.PendingConcept, N.PendingRegistered, N.EnRouteHandedToCarrier, N.EnRouteSorting, N.EnRouteDistribution, N.EnRouteCustoms, N.DeliveredReadyForPickup, N.DeliveredAtRecipient, N.DeliveredPackagePickedUp;
var P = {
	Light: "light",
	Start: "start",
	Plus: "plus",
	Premium: "premium",
	Max: "max"
}, F = {
	Light: 0,
	Start: 1,
	Plus: 2,
	Premium: 3,
	Max: 4
};
F.Light, P.Light, F.Start, P.Start, F.Plus, P.Plus, F.Premium, P.Premium, F.Max, P.Max, P.Light, F.Light, P.Start, F.Start, P.Plus, F.Plus, P.Premium, F.Premium, P.Max, F.Max;
var I = {
	Start: 4800,
	Plus: 4801,
	Premium: 4802,
	Max: 4803
}, L = {
	Start: P.Start,
	Plus: P.Plus,
	Premium: P.Premium,
	Max: P.Max
};
I.Start, L.Start, I.Plus, L.Plus, I.Premium, L.Premium, I.Max, L.Max, L.Start, I.Start, L.Plus, I.Plus, L.Premium, I.Premium, L.Max, I.Max;
var R = {
	Start: 4700,
	Plus: 4701,
	Premium: 4702,
	Max: 4703
}, z = {
	Start: P.Start,
	Plus: P.Plus,
	Premium: P.Premium,
	Max: P.Max
};
R.Start, z.Start, R.Plus, z.Plus, R.Premium, z.Premium, R.Max, z.Max, z.Start, R.Start, z.Plus, R.Plus, z.Premium, R.Premium, z.Max, R.Max;
var B = {
	Light: 4610,
	Start: 4611,
	Plus: 4612,
	Premium: 4613,
	Max: 4614
}, V = {
	Light: P.Light,
	Start: P.Start,
	Plus: P.Plus,
	Premium: P.Premium,
	Max: P.Max
};
B.Light, V.Light, B.Start, V.Start, B.Plus, V.Plus, B.Premium, V.Premium, B.Max, V.Max, V.Light, B.Light, V.Start, B.Start, V.Plus, B.Plus, V.Premium, B.Premium, V.Max, B.Max;
var H = {
	Start: 4615,
	Plus: 4616,
	Premium: 4617,
	Max: 4618
}, U = {
	Start: P.Start,
	Plus: P.Plus,
	Premium: P.Premium,
	Max: P.Max
};
H.Start, U.Start, H.Plus, U.Plus, H.Premium, U.Premium, H.Max, U.Max, U.Start, H.Start, U.Plus, H.Plus, U.Premium, H.Premium, U.Max, H.Max;
var W = {
	MyParcel: 1,
	Flespakket: 2,
	SendMyParcel: 3,
	DeliverDutch: 4,
	PostNlPlugin: 5,
	MyParcelIt: 6
}, G = {
	MyParcel: "myparcel",
	Flespakket: "flespakket",
	SendMyParcel: "belgie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin",
	MyParcelIt: "italie"
}, K = {
	Default: "default",
	MyParcelNl: "myparcel-nederland",
	MyParcelBe: "myparcel-belgie",
	MyParcelIt: "myparcel-italie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin"
};
W.MyParcel, G.MyParcel, W.Flespakket, G.Flespakket, W.SendMyParcel, G.SendMyParcel, W.MyParcelIt, G.MyParcelIt, W.DeliverDutch, G.DeliverDutch, W.PostNlPlugin, G.PostNlPlugin, W.MyParcel, K.MyParcelNl, W.Flespakket, K.MyParcelNl, W.SendMyParcel, K.MyParcelBe, W.MyParcelIt, K.MyParcelIt, W.DeliverDutch, K.DeliverDutch, W.PostNlPlugin, K.PostNlPlugin, K.MyParcelNl, W.MyParcel, K.MyParcelBe, W.SendMyParcel, K.MyParcelIt, W.MyParcelIt, K.MyParcelNl, M.HomeCountry, b.Netherlands, M.Eu, M.Row, b.Belgium, K.MyParcelBe, M.HomeCountry, b.Belgium, b.Netherlands, M.Eu, M.Row, K.MyParcelBe, M.HomeCountry, b.Belgium, M.Eu, M.Row, K.MyParcelNl, M.HomeCountry, b.Netherlands, M.Eu, M.Row, K.MyParcelNl, M.HomeCountry, b.Netherlands, b.Belgium, b.Luxembourg, v.Bpost, v.PostNl, v.DhlForYou, v.DhlParcelConnect, v.DhlEuroPlus, v.Ups, v.UpsStandard, v.UpsExpressSaver;
var q = {
	Package: 1,
	Mailbox: 2,
	Letter: 3,
	DigitalStamp: 4,
	Pallet: 5,
	PackageSmall: 6,
	Envelope: 7
}, J = {
	Package: "package",
	Mailbox: "mailbox",
	Letter: "letter",
	DigitalStamp: "digital_stamp",
	Pallet: "pallet",
	PackageSmall: "package_small",
	Envelope: "envelope"
};
q.Package, J.Package, q.Mailbox, J.Mailbox, q.Letter, J.Letter, q.DigitalStamp, J.DigitalStamp, q.Pallet, J.Pallet, q.PackageSmall, J.PackageSmall, q.Envelope, J.Envelope, J.Package, q.Package, J.Mailbox, q.Mailbox, J.Letter, q.Letter, J.DigitalStamp, q.DigitalStamp, J.Pallet, q.Pallet, J.PackageSmall, q.PackageSmall, J.Envelope, q.Envelope;
var Y = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
};
q.Package, Y.PACKAGE, q.Mailbox, Y.MAILBOX, q.Letter, Y.UNFRANKED, q.DigitalStamp, Y.DIGITAL_STAMP, q.Pallet, Y.PALLET, q.PackageSmall, Y.SMALL_PACKAGE, q.Envelope, Y.ENVELOPE, Y.PACKAGE, q.Package, Y.MAILBOX, q.Mailbox, Y.UNFRANKED, q.Letter, Y.DIGITAL_STAMP, q.DigitalStamp, Y.PALLET, q.Pallet, Y.SMALL_PACKAGE, q.PackageSmall, Y.ENVELOPE, q.Envelope, q.Package, q.Mailbox, q.Letter, q.DigitalStamp, q.Pallet, q.PackageSmall, q.Envelope;
var X = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnrouteHandedToCarrier: 3,
	EnrouteSorting: 4,
	EnrouteDistribution: 5,
	DeliveredAtCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedUnpaidLabel: 12,
	PrintedLetter: 12,
	Credited: 13,
	PrintedStamp: 14,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	PrintedUntrackedShipment: 18,
	DeliveredAtAgreedLocation: 19,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnrouteHandedToCarrier: 32,
	InactiveEnrouteSorting: 33,
	InactiveEnrouteDistribution: 34,
	InactiveEnrouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38,
	CreditRejected: 100,
	CreditApproved: 101
};
X.PendingConcept, X.PendingRegistered, X.EnrouteHandedToCarrier, X.EnrouteSorting, X.EnrouteDistribution, X.DeliveredAtCustoms, X.DeliveredAtRecipient, X.DeliveredPackagePickedUp, X.DeliveredReturnShipmentPackagePickedUp, X.DeliveredAtAgreedLocation, X.PrintedLetter, X.PrintedDigitalStamp, X.InactiveConcept, X.InactiveRegistered, X.InactiveEnrouteHandedToCarrier, X.InactiveEnrouteSorting, X.InactiveEnrouteDistribution, X.InactiveEnrouteCustoms, X.InactiveDeliveredAtRecipient, X.InactiveDeliveredReadyForPickup, X.InactiveDeliveredPackagePickedUp;
//#endregion
//#region src/endpoints/public/track-traces/domain.ts
var vo = [new class extends d {
	name = "getTrackTraces";
	path = "tracktraces";
	property = "tracktraces";
}()], yo = [
	...eo,
	...to,
	...vo,
	...no,
	...uo,
	...lo,
	...Xa,
	...ro,
	...po,
	...go,
	...Za,
	...Qa,
	...mo,
	...$a,
	...ho
], Z, Q;
function bo() {
	return {
		sdk: Z,
		initSdk: (e, t) => {
			if (t && (Q = t), Z) return Z;
			let n = new te({
				baseUrl: e,
				options: { timeout: 8e3 }
			});
			return n.interceptors.request.use((e) => {
				let t = localStorage.getItem("x-dmp-feature-flags");
				return e.headers = {
					"x-referer": window.location.href,
					"x-dmp-feature-flags": t ?? "",
					...Q ? { "Accept-Language": Q } : {},
					...e.headers
				}, e;
			}), Z = ae(n, yo), Z;
		},
		setAcceptLanguageHeader: (e) => {
			Q = e;
		},
		resetSdk: () => {
			Z = void 0;
		}
	};
}
//#endregion
//#region src/test/index.ts
var $ = "test-url", xo = "test-token", So = () => {
	let { initSdk: e } = Ya();
	return e({
		token: xo,
		baseUrl: $
	});
}, Co = () => {
	let { initSdk: e } = bo();
	return e($);
}, wo = {
	IDLE: "idle",
	PENDING: "pending",
	RESOLVED: "resolved",
	REJECTED: "rejected",
	Idle: "idle",
	Pending: "pending",
	Resolved: "resolved",
	Rejected: "rejected"
};
//#endregion
export { ue as DeleteAccountCarrierOption, de as DeleteAccountMessage, pe as DeleteAccountProductPrices, Te as DeleteAddress, Ee as DeleteAddresses, Ve as DeleteBrandingBannerImage, We as DeleteCarrierOptions, Je as DeleteCollectTrip, Ye as DeleteCollectTripSchedule, ut as DeleteDimensionsPresets, mt as DeleteDirectDebitMandate, yt as DeleteExternalIntegrationsProviderCredentialsAmazon, Tt as DeleteExternalIntegrationsProviderCredentialsBol, kt as DeleteExternalIntegrationsProviderCredentialsEtsy, Nt as DeleteExternalIntegrationsProviderCredentialsExact, Lt as DeleteExternalIntegrationsProviderCredentialsExactDe, Ht as DeleteExternalIntegrationsProviderCredentialsWix, on as DeleteFulfilmentOrder, un as DeleteFulfilmentOrderNote, tr as DeleteShippingRule, sr as DeleteShopCarrierOption, cr as DeleteShopImageEmail, br as DeleteSubscription, Ar as DeleteSystemMessages, Br as DeleteUser, Kr as DeleteWebhookSubscriptions, en as FulfilmentDomain, ve as GetAccount, oe as GetAccountActiveBrackets, se as GetAccountBrackets, fe as GetAccountMessages, me as GetAccountProductPrices, ge as GetAccountSupportCases, ye as GetAccounts, Se as GetAcl, we as GetAclRolesAdmin, Ce as GetAclRolesCustomer, De as GetAddress, Oe as GetAddresses, je as GetAnalyticsDashboards, Me as GetApiKeys, Pe as GetBaseProductPrices, p as GetBillingMethods, m as GetBracketRanges, h as GetBrackets, Yr as GetBranding, He as GetCarrierConfigurations, Ge as GetCarrierOptions, ni as GetChamberOfCommerceCompanies, ri as GetCheckShopName, et as GetCheckSubdomain, Xe as GetCollectTripDisabledDays, Ze as GetCollectTripSchedules, Qe as GetCollectTrips, ti as GetCompanyProfile, tt as GetConsumerPortalFields, it as GetDeliveryOptions, ot as GetDimensionsPreset, at as GetDimensionsPresets, dt as GetDirectDebitBanks, ft as GetDirectDebitMandate, ht as GetDropOffPoints, gt as GetEmails, vt as GetEoriNumberCheck, bt as GetExternalIntegrationsProviderCredentialsAmazon, Ct as GetExternalIntegrationsProviderCredentialsBol, Dt as GetExternalIntegrationsProviderCredentialsEtsy, jt as GetExternalIntegrationsProviderCredentialsExact, Ft as GetExternalIntegrationsProviderCredentialsExactDe, Bt as GetExternalIntegrationsProviderCredentialsWix, Wt as GetExternalShipments, Xr as GetFields, nn as GetFulfilmentOrder, sn as GetFulfilmentOrderNotes, pn as GetFulfilmentOrderPackingSlip, hn as GetFulfilmentOrderPicklist, mn as GetFulfilmentOrderScansheet, tn as GetFulfilmentOrders, gn as GetImplications, vn as GetInterimInvoices, yn as GetInvitations, An as GetInvoiceCsvAttachment, jn as GetInvoiceDetailAttachment, kn as GetInvoiceDetailLegacyAttachment, Cn as GetInvoiceDetails, wn as GetInvoiceItemCategories, Mn as GetInvoiceShortAttachment, Sn as GetInvoices, Nn as GetLabelPackagesStatus, In as GetLocations, ii as GetLocationsPublic, Ln as GetPackagings, Bn as GetPaymentGateways, Gn as GetPhoneNumberCheck, Vn as GetPickupLocations, Un as GetPostalCode, Zr as GetPostalCodePublic, Wn as GetPriceScaleBrackets, Hn as GetProductPrice, ur as GetReturnContributions, Fe as GetSepaInstructions, qn as GetShipment, Jn as GetShipments, Zn as GetShippingRules, mr as GetShop, nr as GetShopAccess, ir as GetShopCarrierOptions, pr as GetShopStatistics, Qr as GetSocialShippingLinks, _r as GetSpecialInvoiceItems, vr as GetStatisticsAffiliateCommission, xr as GetSubscriptions, yr as GetSubscriptionsCapabilities, wr as GetSupportCase, Er as GetSupportCaseAttachment, Or as GetSupportCaseReturnReasons, kr as GetSystemCountryCodes, Nr as GetSystemShipmentOptionPrices, Ir as GetTrackAndTrace, Lr as GetUiSettings, Vr as GetUser, Hr as GetUsers, qr as GetWebhookSubscriptions, _e as MyReturnsStatus, st as PatchDimensionsPresets, Qn as PatchShippingRule, Sr as PatchSubscriptions, le as PostAccountCarrierOptions, he as PostAccountProductPrices, xe as PostAccountsAnonymize, ke as PostAddress, Ne as PostApiKeys, Be as PostBrandingBannerImage, Ue as PostCarrierConfiguration, Ke as PostCarrierOptions, $e as PostConnectAffiliates, rt as PostDeliveryNotifications, ct as PostDimensionsPresets, pt as PostDirectDebitMandate, Re as PostEmailCollectionAgencyReport, ze as PostEmailUnpaidInvoices, zt as PostExternalIntegration, xt as PostExternalIntegrationsProviderCredentialsAmazon, wt as PostExternalIntegrationsProviderCredentialsBol, Ot as PostExternalIntegrationsProviderCredentialsEtsy, Mt as PostExternalIntegrationsProviderCredentialsExact, It as PostExternalIntegrationsProviderCredentialsExactDe, Vt as PostExternalIntegrationsProviderCredentialsWix, Gt as PostExternalOrders, Kt as PostExternalShipments, qt as PostFulfilmentDisable, Jt as PostFulfilmentDisableAutosplit, Yt as PostFulfilmentDisablePicqer, Xt as PostFulfilmentEnable, Zt as PostFulfilmentEnableAutosplit, Qt as PostFulfilmentEnablePicqer, $t as PostFulfilmentMode, cn as PostFulfilmentOrderNotes, rn as PostFulfilmentOrders, fn as PostFulfilmentPicqerOrder, _n as PostInterimInvoices, bn as PostInvitation, Tn as PostInvoiceItems, Fn as PostLabelPackages, Ae as PostMarkCreditInvoices, Rn as PostPackaging, zn as PostPaymentInstructions, $r as PostPreRegistration, Pn as PostProcessLabelPackages, ei as PostRegistration, dr as PostReturnContributions, Gr as PostSendVerificationEmail, Ie as PostSepaInstructionsCredit, Le as PostSepaInstructionsDebit, Kn as PostShipmentCarrierPrice, Yn as PostShipments, $n as PostShippingRule, rr as PostShopAccess, ar as PostShopCarrierOptions, hr as PostShopDuplicate, lr as PostShopImageEmail, Dn as PostSpecialInvoices, Cr as PostSubscriptions, Dr as PostSupportCaseComment, En as PostSurchargeUploadUrl, Mr as PostSystemMessages, Pr as PostTicket, Fr as PostTicketAttachment, Rr as PostUiSettings, Ur as PostUsers, Jr as PostWebhookSubscriptions, be as PutAccount, ce as PutAccountBrackets, f as PutAddress, qe as PutCarrierOptions, nt as PutConsumerPortalFields, lt as PutDimensionsPresets, _t as PutEmail, St as PutExternalIntegrationsProviderCredentialsAmazon, Et as PutExternalIntegrationsProviderCredentialsBol, At as PutExternalIntegrationsProviderCredentialsEtsy, Pt as PutExternalIntegrationsProviderCredentialsExact, Rt as PutExternalIntegrationsProviderCredentialsExactDe, Ut as PutExternalIntegrationsProviderCredentialsWix, ln as PutFulfilmentOrderNotes, dn as PutFulfilmentOrderType, an as PutFulfilmentOrders, xn as PutInvitation, On as PutInvoices, fr as PutReturnContributions, Xn as PutShipments, er as PutShippingRule, gr as PutShop, or as PutShopCarrierOptions, Tr as PutSupportCase, jr as PutSystemMessages, zr as PutUiSettings, Wr as PutUsers, wo as Status, xo as TestToken, $ as TestUrl, qa as domains, Ja as privateSdkDomains, Co as testPublicSdk, So as testSdk, bo as usePublicSdk, Ya as useSdk };
